/**
 * @description format price to locale string with decimal separator.
 * @param price - price to format.
 * @param lang - locale string, default is 'zh-TW'.
 * @example 1234567.89 => "1,234,567.89" // (zh-TW)
 */
export const priceFormat = (price: number | string = 0, lang = 'zh-TW') => {
  return (Number(price) || 0)?.toLocaleString(lang)
}
